import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.finecom');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-finecom',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.finecom/view.scss */
:host {
  display: block;
  min-height: 100%;
}

.finecom-page {
  position: relative;
  isolation: isolate;
  min-height: 100svh;
  overflow: hidden;
  background: radial-gradient(circle at 76% 44%, rgba(14, 165, 233, 0.13), transparent 30%), linear-gradient(145deg, #07152c 0%, #0a1d3a 48%, #061124 100%);
}

.finecom-gradient {
  position: absolute;
  z-index: -2;
  top: -430px;
  right: -250px;
  width: 920px;
  height: 920px;
  border-radius: 9999px;
  background: radial-gradient(circle, rgba(59, 130, 246, 0.22) 0%, rgba(14, 165, 233, 0.07) 44%, transparent 70%);
  pointer-events: none;
}

.finecom-pattern {
  position: absolute;
  z-index: -1;
  inset: 0;
  opacity: 0.2;
  background-image: linear-gradient(rgba(125, 211, 252, 0.1) 1px, transparent 1px), linear-gradient(90deg, rgba(125, 211, 252, 0.1) 1px, transparent 1px);
  background-size: 64px 64px;
  mask-image: linear-gradient(100deg, black, transparent 76%);
  -webkit-mask-image: linear-gradient(100deg, black, transparent 76%);
  pointer-events: none;
}

.finecom-mark {
  display: flex;
  position: relative;
  width: 40px;
  height: 40px;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  border: 1px solid rgba(125, 211, 252, 0.2);
  border-radius: 13px;
  background: rgba(14, 165, 233, 0.1);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.08);
}

.mark-dot {
  position: absolute;
  width: 9px;
  height: 9px;
  border-radius: 9999px;
  background: #7dd3fc;
  box-shadow: 0 0 14px rgba(125, 211, 252, 0.55);
}

.mark-line {
  position: absolute;
  width: 26px;
  height: 1px;
  background: linear-gradient(90deg, transparent, #7dd3fc, transparent);
  transform: rotate(-38deg);
}

.signal-dot {
  width: 7px;
  height: 7px;
  border-radius: 9999px;
  background: #7dd3fc;
  box-shadow: 0 0 0 0 rgba(125, 211, 252, 0.28);
  animation: signal-pulse 2.2s ease-out infinite;
}

.network-stage {
  border-radius: 9999px;
  background: radial-gradient(circle, rgba(14, 165, 233, 0.11), transparent 66%);
}

.network-circle {
  position: absolute;
  border: 1px solid rgba(125, 211, 252, 0.16);
  border-radius: 9999px;
}

.circle-one {
  inset: 4%;
  border-style: dashed;
  animation: network-spin 30s linear infinite;
}

.circle-two {
  inset: 21%;
  animation: network-spin 22s linear infinite reverse;
}

.circle-three {
  inset: 38%;
  border-color: rgba(125, 211, 252, 0.24);
}

.logo-core {
  display: grid;
  position: relative;
  z-index: 3;
  width: 112px;
  height: 112px;
  grid-template-columns: 1fr 1fr;
  align-items: center;
  color: white;
  border: 1px solid rgba(125, 211, 252, 0.2);
  border-radius: 32px;
  background: linear-gradient(145deg, rgba(14, 165, 233, 0.22), rgba(37, 99, 235, 0.16));
  box-shadow: 0 28px 65px rgba(0, 0, 0, 0.3), inset 0 1px 0 rgba(255, 255, 255, 0.11);
  backdrop-filter: blur(16px);
}

.logo-core span {
  display: flex;
  height: 48px;
  align-items: center;
  justify-content: center;
  font-size: 22px;
  font-weight: 800;
}

.logo-core span + span {
  border-left: 1px solid rgba(125, 211, 252, 0.2);
}

.connection {
  position: absolute;
  z-index: 1;
  width: 108px;
  height: 1px;
  transform-origin: left center;
  background: linear-gradient(90deg, rgba(125, 211, 252, 0.65), transparent);
}

.connection-one {
  top: 28%;
  left: 51%;
  transform: rotate(-35deg);
}

.connection-two {
  right: 25%;
  bottom: 38%;
  transform: rotate(150deg);
}

.connection-three {
  bottom: 30%;
  left: 30%;
  transform: rotate(225deg);
}

.network-node {
  position: absolute;
  z-index: 2;
  width: 11px;
  height: 11px;
  border: 2px solid #0a1d3a;
  border-radius: 9999px;
  background: #7dd3fc;
  box-shadow: 0 0 20px rgba(125, 211, 252, 0.55);
}

.node-a {
  top: 15%;
  right: 24%;
}

.node-b {
  right: 14%;
  bottom: 28%;
}

.node-c {
  bottom: 18%;
  left: 22%;
}

@keyframes signal-pulse {
  0% {
    box-shadow: 0 0 0 0 rgba(125, 211, 252, 0.32);
  }
  70% {
    box-shadow: 0 0 0 9px rgba(125, 211, 252, 0);
  }
  100% {
    box-shadow: 0 0 0 0 rgba(125, 211, 252, 0);
  }
}
@keyframes network-spin {
  to {
    transform: rotate(360deg);
  }
}
@media (prefers-reduced-motion: reduce) {
  .signal-dot,
  .network-circle {
    animation: none;
  }
}`],
})
export class PageFinecomComponent implements OnInit {
    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        await this.service.render();
    }

    public navigateHome(event?: MouseEvent) {
        if (!event || event.button !== 0 || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) {
            return;
        }

        event.preventDefault();
        this.service.href('/');
    }
}

export default PageFinecomComponent;